import { Link } from "react-router-dom";
import { ArrowRight, Mail, Clock, Instagram, Facebook, Linkedin } from "lucide-react";
import Logo from "./Logo";

const FOOTER_CITIES = [
  ["rennes", "Rennes"], ["brest", "Brest"], ["quimper", "Quimper"], ["lorient", "Lorient"],
  ["vannes", "Vannes"], ["saint-malo", "Saint-Malo"], ["saint-brieuc", "Saint-Brieuc"], ["lanester", "Lanester"],
  ["concarneau", "Concarneau"], ["fougeres", "Fougères"], ["lannion", "Lannion"], ["vitre", "Vitré"],
];

export const DEPARTMENTS = [
  ["finistere", "Finistère"], ["cotes-d-armor", "Côtes-d'Armor"], ["ille-et-vilaine", "Ille-et-Vilaine"], ["morbihan", "Morbihan"],
  ["manche", "Manche"], ["mayenne", "Mayenne"], ["orne", "Orne"],
];

const NAV = [
  ["/villes", "Toutes les communes"], ["/simulateur", "Simulateur de revenus"], ["/devis", "Devis conciergerie"],
  ["/qui-sommes-nous", "Qui sommes-nous"], ["/devenir-partenaire", "Vous êtes conciergerie ?"], ["/badge-partenaire", "Badge partenaire"], ["/blog", "Blog"], ["/contact", "Contact"],
];

const LINK = "text-primary-foreground/75 hover:text-white transition-colors";
const Title = ({ children }) => <h4 className="text-xs uppercase tracking-[0.18em] text-[hsl(var(--ocean))] font-bold mb-5">{children}</h4>;

const LinkList = ({ items, prefix = "", testid, cols = 1 }) => (
  <ul className={`grid ${cols === 2 ? "grid-cols-2" : "grid-cols-1"} gap-x-6 gap-y-3 text-sm`}>
    {items.map(([to, label]) => (
      <li key={to}><Link to={prefix + to} className={LINK} data-testid={`${testid}-${to.replace(/\//g, "") || "home"}`}>{label}</Link></li>
    ))}
  </ul>
);

const Brand = () => (
  <div data-testid="footer-brand">
    <Logo variant="light" size="lg" />
    <p className="mt-6 text-sm text-primary-foreground/70 max-w-xs leading-relaxed">
      Le comparateur indépendant de conciergeries Airbnb, partout en Bretagne. Une seule demande, la bonne conciergerie pour votre bien, et 0 € pour le propriétaire.
    </p>
    <Link to="/devis" className="btn-accent mt-6" data-testid="footer-cta-devis">Demander mon devis <ArrowRight size={16} /></Link>
  </div>
);

const ContactCol = () => (
  <div>
    <Title>Nous joindre</Title>
    <ul className="space-y-3 text-sm text-primary-foreground/75">
      <li className="flex gap-2.5"><Mail size={15} className="text-[hsl(var(--ocean))] shrink-0 mt-0.5" /><a href="mailto:contact@bretagneconciergerie.fr" className="hover:text-white break-all" data-testid="footer-email">contact@bretagneconciergerie.fr</a></li>
      <li className="flex gap-2.5"><Clock size={15} className="text-[hsl(var(--ocean))] shrink-0 mt-0.5" />7j/7, de 10h à 20h</li>
    </ul>
    <div className="mt-6 flex gap-3">
      {[Instagram, Facebook, Linkedin].map((Icon, i) => (
        <a key={i} href="#" aria-label="Réseau social" className="w-10 h-10 rounded-full bg-white/10 hover:bg-accent flex items-center justify-center transition-colors" data-testid={`footer-social-${i}`}>
          <Icon size={16} />
        </a>
      ))}
    </div>
  </div>
);

export default function Footer() {
  return (
    <footer className="bg-primary text-primary-foreground mt-24 rounded-t-[40px] overflow-hidden" data-testid="site-footer">
      <div className="container-tm py-16 grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-12 gap-10">
        <div className="sm:col-span-2 lg:col-span-3"><Brand /></div>
        <div className="lg:col-span-2"><Title>Naviguer</Title><LinkList items={NAV} testid="footer-nav" /></div>
        <div className="lg:col-span-3"><Title>Conciergerie par ville</Title><LinkList items={FOOTER_CITIES} prefix="/villes/" testid="footer-city" cols={2} /></div>
        <div className="lg:col-span-2"><Title>Départements</Title><LinkList items={DEPARTMENTS} prefix="/departements/" testid="footer-dept" /></div>
        <div className="lg:col-span-2"><ContactCol /></div>
      </div>
      <div className="border-t border-white/10">
        <div className="container-tm py-6 flex flex-col md:flex-row items-center justify-between gap-3 text-xs text-primary-foreground/60 text-center">
          <span>© {new Date().getFullYear()} Bretagne Conciergerie Comparateur. Comparateur indépendant, 0 € pour les propriétaires.</span>
          <span><Link to="/politique-de-confidentialite" className="hover:text-white" data-testid="footer-privacy">Politique de confidentialité</Link></span>
        </div>
      </div>
    </footer>
  );
}
